import type { TransportAirport } from '@/domainLogic/index.ts';
import type { AirportPopupProps, HandleAirportClicked } from './index';

export type CreateAirportPopupProps = {
  airportSelected: TransportAirport;
  multiAirportsSelected: boolean;
  handleAirportClicked: HandleAirportClicked;
};

export const createAirportPopupProps = ({
  airportSelected,
  multiAirportsSelected,
  handleAirportClicked,
}: CreateAirportPopupProps): AirportPopupProps => {
  const { iata, name, selected, isStation } = airportSelected;

  return {
    iata,
    name,
    selected,
    multiAirportsSelected,
    handleAirportClicked,
    isStation,
  };
};
